import React, { useState } from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg';
import shape1 from '../../../images/shapes/shape_line_2.svg';
import shape2 from '../../../images/shapes/shape_line_3.svg';
import shape3 from '../../../images/shapes/shape_line_4.svg';
import shape4 from '../../../images/shapes/shape_space_2.svg';
import TechnologySection from "../TechnologySection/TechnologySection";

const steps = [
    {
        id: 1,
        title: "Onderzoeksfase",
        description: "In deze fase brengen we de behoeften en risico's van scale-ups en MKB'ers in kaart. We analyseren hun digitale omgevingen om te begrijpen waar de grootste kwetsbaarheden liggen en welke penetratietests hen het meest ten goede komen.",
    },
    {
        id: 2,
        title: "Design and Development",
        description: "We ontwerpen de AI-gebaseerde scanner die specifiek is afgestemd op het vinden van bekende kwetsbaarheden (CVE’s) en bouwen modules voor geautomatiseerde en gerichte penetratietests. Hier leggen we de technische basis voor een gebruiksvriendelijke, efficiënte beveiligingstool.",
    },
    {
        id: 3,
        title: "Testing and QA",
        description: "In deze fase ondergaat Praeventor AI grondige tests om ervoor te zorgen dat de kwetsbaarheidsscans nauwkeurig zijn en de penetratietests effectief werken. We voeren real-world simulaties uit om de prestaties en betrouwbaarheid te waarborgen.",
    },
    {
        id: 4,
        title: "Deployment",
        description: "De tool wordt geïmplementeerd bij een selecte groep pilot-klanten. We integreren Praeventor AI in hun digitale omgevingen, begeleiden hen bij de eerste scans, en verzamelen feedback om onze beveiligingsdiensten verder te verfijnen.",
    },
    {
        id: 5,
        title: "Maintenance and Continuous Improvement",
        description: "Na de implementatie bieden we doorlopende ondersteuning en updates om nieuwe kwetsbaarheden en bedreigingen aan te pakken. We blijven Praeventor AI verbeteren om altijd een stap voor te blijven op het gebied van cybersecurity.",
    }
];

const ProcessTechnology = () => {
    const [activeStep, setActiveStep] = useState(2);

    const handleStepClick = (stepId) => {
        setActiveStep(stepId);
    };

    return (
        <section className="process_technology_review_section section_decoration">
            <div className="container">
                <div className="heading_block mb-5">
                    <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                        Onze voortgang
                    </div>
                    <h2 className="heading_text mb-0">
                        Denk jij mee aan onze <mark>voortgang</mark>?
                    </h2>
                </div>

                <div className="steps_container">
                    {steps.map((step, index) => (
                        <div
                            key={step.id}
                            className={`step_item ${activeStep === step.id ? 'active' : ''}`}
                            onClick={() => handleStepClick(step.id)}
                            style={{
                                backgroundColor: activeStep === step.id ? '#f0f0f5' : 'white',
                                border: '1px solid #e0e0e0',
                                padding: '20px',
                                marginBottom: '20px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                            }}
                        >
                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#2c3e50' }}>
                                {`${step.id}. ${step.title}`}
                            </div>
                            <div style={{ marginTop: '10px', color: '#555' }}>
                                {activeStep === step.id && <p>{step.description}</p>}
                            </div>
                        </div>
                    ))}
                </div>
                <TechnologySection />
            </div>

            {/* Decorations */}
            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="Techco Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="Techco Shape" />
            </div>
            <div className="decoration_item shape_image_3">
                <img src={shape3} alt="Techco Shape" />
            </div>
            <div className="decoration_item shape_image_4">
                <img src={shape4} alt="Techco Shape" />
            </div>
        </section>
    );
};

export default ProcessTechnology;
